import { render, staticRenderFns } from "./IconSettingsProofread.vue?vue&type=template&id=2b015bbe&"
import script from "./IconSettingsProofread.vue?vue&type=script&lang=js&"
export * from "./IconSettingsProofread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b015bbe')) {
      api.createRecord('2b015bbe', component.options)
    } else {
      api.reload('2b015bbe', component.options)
    }
    module.hot.accept("./IconSettingsProofread.vue?vue&type=template&id=2b015bbe&", function () {
      api.rerender('2b015bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSettingsProofread.vue"
export default component.exports